import React, { useState } from 'react';
import { useController } from './controller';
import { useParticles } from './particles';
import * as S from './styles';
import DefaultLoading from '../../components/DefaultLoading';
import { translations, LanguageKeys } from './translation';
import { Helmet } from "react-helmet"

const LandingPage = (props: any) => {
    const controller = useController();

    return (
        <S.mainContainer>
            <Helmet>
                <meta name="keywords"
                    content="plataforma de estudos com IA, aprendizado personalizado, flashcards inteligentes, testes personalizados, análise de aprendizado, sessões de estudo, rastreador de progresso, estudar com IA, LearnArez, inteligência artificial para educação, IA para estudantes, gerador de flashcards, planejador de estudos, assistente de aprendizado, aprendizado rápido, aprendizado acelerado, plataforma adaptativa, tutor inteligente, ferramentas de estudo online" />
                <meta name="description"
                    content="O LearnArez é uma plataforma de estudos inteligente com IA, que oferece sessões personalizadas, flashcards inteligentes e testes sob medida para tornar seu aprendizado mais rápido, fácil e eficiente." />
                <meta name="category"
                    content="Educação, Inteligência Artificial, Ferramentas de Aprendizado" />
                <meta property="og:description"
                    content="O LearnArez é uma plataforma de estudos inteligente com IA, que oferece sessões personalizadas, flashcards inteligentes e testes sob medida para tornar seu aprendizado mais rápido, fácil e eficiente." />
            </Helmet>

            <S.loginHeader>
                <S.logo src={`./images/Logo_and_name_transparent_bg_var.png`} alt="Logo" />
                <S.headerButtonsWrapper>
                    <S.headerButton onClick={() => controller.general.GoToRoute('/login')}>
                        {translations['PTBR'].ctaButtonLogin}
                    </S.headerButton>
                    <S.headerButton onClick={() => controller.general.GoToRoute('/register')}>
                        {translations['PTBR'].ctaButtonRegister}
                    </S.headerButton>
                </S.headerButtonsWrapper>
            </S.loginHeader>
            <S.mainInfo>
                <S.ctaArea>
                    <S.mainTitle>
                        {translations['PTBR'].mainTitle}
                    </S.mainTitle>
                    <S.subTitle>
                        {translations['PTBR'].subTitle}
                    </S.subTitle>
                    <S.startCta onClick={() => controller.general.GoToRoute('/register')}>
                        {translations['PTBR'].ctaButton}
                    </S.startCta>
                </S.ctaArea>
                <S.imageArea>
                    <S.mainImage src={`./images/showing_responsive_layout.png`} alt="Landing Page" />
                </S.imageArea>
            </S.mainInfo>
            <S.infobitsArea>
                {translations['PTBR'].advantages.map((infobit, index) => (
                    <S.infobit>
                        <S.infobitTitle>
                            {infobit.title}
                        </S.infobitTitle>
                        <S.infobitSubtitle>
                            {infobit.description}
                        </S.infobitSubtitle>
                    </S.infobit>
                ))}
            </S.infobitsArea>
            <S.persuasiveInfo>
                <S.persuasiveTextArea>
                    <S.persuasiveTitle>
                        {translations['PTBR']['persuasiveInfoOne'].title}
                    </S.persuasiveTitle>
                    <S.persuasiveText>
                        {translations['PTBR']['persuasiveInfoOne'].text}
                    </S.persuasiveText>
                </S.persuasiveTextArea>
                <S.persuasiveImage src={`./images/info_learnarez_1.png`} alt="Info image 1" />
            </S.persuasiveInfo>
            <S.persuasiveInfo className='reverse'>
                <S.persuasiveTextArea>
                    <S.persuasiveTitle>
                        {translations['PTBR']['persuasiveInfoTwo'].title}
                    </S.persuasiveTitle>
                    <S.persuasiveText>
                        {translations['PTBR']['persuasiveInfoTwo'].text}
                    </S.persuasiveText>
                </S.persuasiveTextArea>
                <S.persuasiveImage src={`./images/info_learnarez_2.png`} alt="Info image 1" />
            </S.persuasiveInfo>
            <S.pageTitle>
                {translations['PTBR'].frequentlyAskedQuestionsTitle}
            </S.pageTitle>
            <S.infobitsArea>
                {translations['PTBR'].frequentlyAskedQuestions.map((infobit, index) => (
                    <S.infobit>
                        <S.infobitTitle>
                            {infobit.question}
                        </S.infobitTitle>
                        <S.infobitSubtitle>
                            {infobit.answer}
                        </S.infobitSubtitle>
                    </S.infobit>
                ))}
            </S.infobitsArea>
            <S.lastCtaText>
                {translations['PTBR'].lastCTA}
            </S.lastCtaText>
            <S.lastCta onClick={() => controller.general.GoToRoute('/register')}>
                {translations['PTBR'].ctaButton}
            </S.lastCta>
            <S.footer>
                LearnArez © {new Date().getFullYear()} - Todos os direitos reservados.
            </S.footer>
        </S.mainContainer>
    )
}

const MountedComponent = (props: any) => {
    const particles = useParticles();

    return (
        <>
            <LandingPage />
        </>
    )
}

export default MountedComponent;